import React from 'react'
import { Tooltip as AntdTooltip } from 'antd'
import { TooltipProps } from 'antd/lib/tooltip'

const Tooltip = (props: TooltipProps) => {
  return <AntdTooltip overlayStyle={{ lineHeight: '1.6' }} {...props} />
}

export default Tooltip
